<!-- 主页 -->
<template>
  <Header></Header>
</template>

<script>
import Header from './Header.vue'
export default {
  name: 'Home',
  data () {
    return {}
  },
  components: { Header },
  mounted () { },
  methods: { }
}
</script>


// WEBPACK FOOTER //
// src/components/Home.vue